import React, { useEffect, useState } from 'react';

export default function Unsubscribe() {
  const [status, setStatus] = useState('loading');
  const [channel, setChannel] = useState('email');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uid = params.get('uid');
    const ch = params.get('channel') || 'email';
    setChannel(ch);

    if (!uid) { setStatus('error'); return; }

    fetch(`/api/users/unsubscribe?uid=${uid}&channel=${ch}`)
      .then(r => r.json())
      .then(data => {
        if (data.ok) setStatus('done');
        else setStatus('error');
      })
      .catch(() => setStatus('error'));
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9f6f2', fontFamily: 'Georgia, serif' }}>
      <div style={{ background: '#fff', borderRadius: '14px', padding: '2.5rem 2rem', maxWidth: '420px', width: '90%', textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
        {status === 'loading' && (
          <p style={{ color: '#888' }}>Processing your request…</p>
        )}
        {status === 'done' && (
          <>
            <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>✓</div>
            <h2 style={{ color: '#5D4037', margin: '0 0 0.75rem' }}>You've been unsubscribed</h2>
            <p style={{ color: '#666', lineHeight: 1.7, margin: '0 0 1.5rem', fontSize: '0.95rem' }}>
              {channel === 'email'
                ? "You'll no longer receive email reminders from String. If you signed up for text reminders, those will continue."
                : "You'll no longer receive text reminders from String. If you signed up for email reminders, those will continue."}
            </p>
            <a href="/" style={{ color: '#5D4037', fontSize: '0.9rem' }}>Return to String</a>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 style={{ color: '#5D4037', margin: '0 0 0.75rem' }}>Something went wrong</h2>
            <p style={{ color: '#666', fontSize: '0.95rem' }}>
              We couldn't process your request. Please reply STOP to any text from us, or contact us directly.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
